import { Site } from '@envato/foundation-types'
import { isDevelopment, isStaging, isE2ETest } from './envHelper'

// themeforest -> themeforest.net
export const getCurrentSiteDomain = (currentSite: Site) => {
  if (isDevelopment() || isE2ETest()) {
    return `${currentSite}.test`
  } else if (isStaging()) {
    return `${currentSite}-staging.net`
  } else {
    return `${currentSite}.net`
  }
}

// themeforest.net -> themeforest
// themeforest-staging.net -> themeforest
export const getCurrentSiteFromDomain = (domain: string) => {
  const site = domain.split('.')[0].split('-')[0] as Site

  if (Object.values(Site).includes(site)) {
    return site
  }

  return undefined
}
